import { render } from "./ProductsSlider.vue?vue&type=template&id=5fbe58aa"
import script from "./ProductsSlider.vue?vue&type=script&lang=js"
export * from "./ProductsSlider.vue?vue&type=script&lang=js"

import "./ProductsSlider.vue?vue&type=style&index=0&id=5fbe58aa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__